<canvas id="homePageChart"></canvas>
